// UQ-fr-BE
module.exports = {
  "forTest": "test for UQ-fr-BE",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Looks officiels",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Trier par",
  "text_filter": "Filtre",
  "text_styling_book_search_results_number": "{total} résultats",
  "text_active_filters": "Filtres actifs",
  "text_styling_book_clear_all_filters": "Tout effacer",
  "text_styling_book_search_by_feature": "Rechercher par caractéristique",
  "text_styling_book_search_by_category": "Rechercher par catégorie",
  "text_styling_book_staff_customer_filter_all": "Tout",
  "text_styling_book_search_by_coordinate": "Rechercher par coordonnées",
  "text_styling_book_staff_customer_filter_title": "Personnel / Client",
  "text_styling_book_search_by_height": "Rechercher par taille",
  "text_styling_book_search_by_hashtag": "Rechercher par hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Looks des clients",
  "text_styling_book_staff_customer_filter_staff_styling": "Looks du personnel",
  "text_apply_search_filter": "Appliquer",
  "text_styling_book_no_results": "Aucun résultat",
  "text_error_title": "Service temporairement indisponible",
  "text_503_error_description-1": "Toutes nos excuses. Une erreur s’est produite.",
  "text_503_error_description-2": "Veuillez accéder au site plus tard ou retourner à la page précédente à l'aide du bouton précédent.",
  "text_503_error_instruction": "Pour toute question, veuillez vous rendre sur la page NOUS CONTACTER.",
  "text_styling_book_go_to_top": "Accueil UNIQLO",
  "text_contactus": "Contactez-nous",
  "text_wishlist": "Favoris",
  "text_membership_info": "Mon compte",
  "text_wearing_items": "Articles à porter",
  "text_color": "Coloris",
  "text_size": "Taille",
  "text_stylehint_non_listed_items_message_01": "*Les produits qui ne sont pas affichés sont indisponibles.",
  "text_styling_book_related_styling_title": "Looks similaires",
  "text_style_styling_date_update": "Mettre à jour",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} €",
  "text_404": "Page introuvable",
  "text_official_styling_top_page_link": "Looks officiels",
  "text_stylehint_top_page_link": "StyleHint top page",
  "text_breadcrumbs_top": "Page d'accueil UNIQLO",
  "text_a11y_close": "Fermer",
  "text_log_in": "S'identifier",
  "text_app_update_dialog_cancel": "Annuler",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Tous droits réservés.",
  "text_stylehintapp": "Appli StyleHint",
  "text_styling_book_official_styling_page_title": "Looks officiels",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Nouveautés",
  "text_styling_book_sort_popular": "Les plus populaires",
  "text_styling_book_search_by_color": "Rechercher par couleur",
  "text_filter_clear_all_category": "Effacer toutes les catégories",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Afficher tout",
  "text_error_description": "Une erreur système s’est produite. Veuillez réessayer plus tard.",
  "text_system_error": "Erreur de système",
  "text_ok": "OK",
  "text_login_required": "Ouverture de session requise",
  "text_login_request": "Veuillez aller à la page d'ouverture de session.",
  "text_error_failed_sort_product": "Les produits n’ont pas pu être triés sur la base des critères que vous avez sélectionnés. Relancez la fonction de tri.",
  "text_error_failed_update_filter_criteria": "Le critère de filtrage n’a pas pu être mis à jour. Veuillez réessayer.",
  "text_meta_title_postfix": "| UNIQLO BE",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Femme",
  "text_styling_book_meta_men": "Homme",
  "text_styling_book_meta_kids": "Enfant",
  "text_styling_book_meta_baby": "Bébé",
  "text_styling_book_official_gender_meta_description": "Découvrez le lookbook officiel de la marque. Parcourez-le et découvrez des tenues tendance et des astuces pour des looks de la collection {gender}.",
  "text_styling_book_official_gender_meta_title": "Découvrez les looks de la saison | {gender} | Nos looks {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender} 「{filterOptions}」Idées de looks {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Découvrez les looks {gender}「{filterOptions}」et les inspirations de {brand}. Nos idées looks tendances à découvrir.",
  "text_styling_book_official_detail_meta_title": "Découvrez les looks avec「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Découvrez les nouveaux looks de「{officialProducts}」et adoptez la tenue {brand}.com dès maintenant !",
  "text_styling_book_stylehint_gender_meta_title": "Les nouvelles idées looks | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Trouvez l'inspiration {gender} grâce aux clients UNIQLO {brand} et notre équipe sur l'appli StyleHint;",
  "text_styling_book_stylehint_filter_meta_title": "{gender} 「{filterOptions}」Idées de looks {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Les idées looks de {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Les idées looks de {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Les idées looks de {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Voir les idées looks de「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "En savoir plus sur les looks de {staffName}({height}) de {brand}({storeName}). Découvrez comment nos équipes portent les pièces cultes UNIQLO.",
  "text_styling_book_stylehint_ins_user_meta_description": "Découvrez les looks de「{userName}」sur Instagram avec {brand}.  Mais aussi, les looks des autres utilisateurs !",
  "text_styling_book_stylehint_customer_user_meta_description": "Découvrez les looks de {userName} ({height}) avec les articles {brand}. Mais aussi, portés par les mannequins en magasin/",
  "text_styling_book_stylehint_detail_meta_description": "Les nouveaux looks sont à découvrir avec「{stylehintProducts}」portés par nos clients {brand} et notre équipe. La tenue vous attend sur {brand}.com dès maintenant !",
  "text_styling_book_stylehint_filter_meta_description": "Voir「{searchCount}」les idées looks de「{filterOptions}」avec les pièces de {brand}. C'est à ne pas manquer !",
  "text_styling_book_stylehint_styling_id_alt_tag": "LOOKBOOK de {brand} ID du look : <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "LOOKBOOK de {brand} ID du look : <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Découvrez les idées looks de「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Découvrez les idées de tenues de「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Idées de tenues pour {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Idées de style pour {gender} 「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Toutes nos excuses. Une erreur s'est produite. Veuillez accéder au site plus tard ou retourner à la page précédente à l'aide du bouton précédent.",
  "text_styling_book_meta_official_styling": "Idées de looks",
  "text_styling_book_meta_stylehint": "Idées de tenues",
  "text_limited_offer_until_date": "Offre à durée limitée valable jusqu’au {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Offre exclusive de la boutique en ligne valable jusqu’au {date}",
  "text_app_membership_exclusive_limited_offer_until": "Carte d’abonnement limitée jusqu’au {date}",
  "text_csoon_early": "Disponible début {month}",
  "text_csoon_mid": "Disponible mi-{month}",
  "text_csoon_late": "Disponible fin {month}",
  "text_men": "Homme",
  "text_women": "Femme",
  "text_kids": "Enfant",
  "text_baby": "Bébé",
  "text_unisex": "Unisexe",
  "text_app_membership_exclusive_limited_offer": "Carte d’abonnement limitée",
  "text_styling_book_gender_menu_kids_and_baby": "Enfant / Bébé",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Ajouter à la liste de souhaits",
  "text_close": "Fermer",
  "text_error_wishlist_max": "Cet article ne peut pas être ajouté. Vous avez dépassé le nombre maximum d'articles sur votre liste de souhaits.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Aucune image",
  "text_wearing_size_code01": "Taille du vêtement : {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "Français",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "Nederlands",
  "text_product_unavailable": "Ce produit n'est plus commercialisé.",
  "text_product_display_markdown": "",
  "text_color_white": "Blanc",
  "text_color_gray": "Gris",
  "text_color_black": "Noir",
  "text_color_pink": "Rose",
  "text_color_red": "Rouge",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Marron",
  "text_color_yellow": "Jaune",
  "text_color_green": "Vert",
  "text_color_blue": "Bleu",
  "text_color_purple": "Violet",
  "text_promotion": "Promotion",
  "text_styling_promotion_hashtag": "Promotion",
  "text_coming_soon": "Arrive bientôt",
  "text_markdown": "Démarque",
  "text_multibuy_markdown": "Achats multiples, démarques",
  "text_multibuy_limited_offer_until_date": "Achats multiples, offre limitée valable jusqu’au {date}",
  "text_app_membership_exclusive_multi_buy_until": "Offre exclusive sur les lots en ligne et sur l'appli jusqu'au {date}",
  "text_app_membership_exclusive_multi_buy": "Offre exclusive sur les lots en ligne et sur l'appli",
  "text_app_membership_exclusive_limitedoffers_until": "Offre exclusive en ligne et sur l'appli jusqu'au {date}",
  "text_item_preorder_color_size_only": "Précommander (couleurs / tailles sélectionnées)",
  "text_item_resale_color_size_only": "De nouveau disponible (couleurs / tailles sélectionnées)"
}; // generated at Tue Jul 29 2025 17:10:25 GMT+0800 (Hong Kong Standard Time)